module.exports = __webpack_public_path__ + "img/40_38_058_820.388d8e54.jpg";